<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-xl-mb-0 mb-3">
                <div class="position-relative" :class="{'merlin-asset-border': isMerlinMedia(question.content.image.src)}">
                    <div v-if="isMerlinMedia(question.content.image.src)" class="merlin-asset-wrapper">
                        <span class="merlin-asset-warning">
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                            Merlin Asset
                        </span>
                    </div>
                    <b-img :src="question.content.image.src" :height="question.content.image.height" :width="question.content.image.width" />
                    <div v-for="(label, index) in question.content.labels" :key="index">
                        <b-badge variant="warning" class="rounded" v-tack:top="label.dot.offsetY - 13" v-tack:left="label.dot.offsetX - 13">
                            {{index + 1}}
                        </b-badge>
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div v-show="question.content.labels && question.content.labels.length" class="mb-3">
                    <h6>Labels</h6>
                    <b-list-group>
                        <b-list-group-item
                            v-for="(label, index) in question.content.labels"
                            :key="index"
                        >
                            <div v-if="!label.type || label.type == 'text'">
                                {{index + 1}}. {{label.text}}
                            </div>
                            <div v-else class="image-label-container" :class="{'merlin-asset-border': isMerlinMedia(label.url)}">
                                <div v-if="isMerlinMedia(label.url)" class="merlin-asset-wrapper">
                                    <span class="merlin-asset-warning">
                                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                        Merlin Asset
                                    </span>
                                </div>
                                {{index + 1}}.
                                <b-img :src="label.url" class="image-label" />
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div v-show="question.content.incorrect_clues && question.content.incorrect_clues.length">
                    <h6>Incorrect Clues</h6>

                    <b-list-group>
                        <b-list-group-item
                            v-for="(clue, index) in question.content.incorrect_clues"
                            :key="index"
                        >
                            <div v-if="!clue.type || clue.type == 'text'">{{clue.text}}</div>
                            <div v-else class="image-clue-container" :class="{'merlin-asset-border': isMerlinMedia(clue.url)}">
                                <div v-if="isMerlinMedia(clue.url)" class="merlin-asset-wrapper">
                                    <span class="merlin-asset-warning">
                                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                        Merlin Asset
                                    </span>
                                </div>
                                <b-img
                                    :src="clue.url"
                                    class="image-clue"
                                />
                            </div>
                        </b-list-group-item>

                    </b-list-group>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .image-clue-container, .image-label-container {
        height: 100px;
        max-height: 100px;
    }

    .image-clue, .image-label {
        max-height: 90%;
        max-width: 90%;
        height: auto;
    }
</style>

<script>
import Vue from 'vue'

Vue.directive('tack', {
    bind (el, binding) {
        el.style.position = 'absolute'
        const s = (binding.arg == 'left' ? 'left' : 'top')
        el.style[s] = binding.value + 'px'
    }
})

export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {
        isMerlinMedia(image) {
            return image.toLowerCase().includes('merlinone')
        },
    }
}
</script>
